<template>
  <label
    :class="[
      'flex min-w-0 flex-row items-center gap-2 select-none',
      disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
    ]"
  >
    <input
      v-bind="inputAttrs"
      v-model="checkedModel"
      type="checkbox"
      class="peer sr-only shrink-0 focus:outline-none focus-visible:outline-none"
      :required="required"
      :disabled="disabled"
    />
    <slot
      name="icon"
      :checked-model="checkedModel"
    >
      <CheckTrueIcon
        v-if="checkedModel"
        class="!size-5 text-blue-500"
        color="currentColor"
      />
      <CheckFalseIcon
        v-else
        class="!size-5 text-white"
      />
    </slot>
    <div class="min-w-0 flex-1 text-sm font-medium leading-5 text-gray-900 pb-px">
      <slot :label="label" />
    </div>
  </label>
</template>

<script setup>
import { computed } from 'vue'
import CheckFalseIcon from '~/assets/svg/ui/check-false.svg'
import CheckTrueIcon from '~/assets/svg/ui/check-true.svg'

const props = defineProps({
  id: {
    type: [String, Number],
    default: undefined,
  },
  checked: {
    type: Boolean,
    default: false,
  },
  label: {
    type: [String, Number],
    default: '',
  },
  value: {
    type: [String, Number, Object],
    default: '',
  },
  slug: {
    type: String,
    default: '',
  },
  required: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['clickCheckbox'])

const checkedModel = computed({
  get () {
    return props.checked
  },
  set (checked) {
    emit('clickCheckbox', {
      id: props.id,
      value: props.value,
      checked,
      slug: props.slug,
    })
  },
})

const inputAttrs = computed(() => {
  const attrs = {}
  if (props.id !== undefined && props.id !== null && props.id !== '') {
    attrs.id = String(props.id)
  }
  return attrs
})
</script>
